import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">隐私政策</h1>
        
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600 mb-6">
              南昌市玉洒贸易有限公司（以下简称"我们"或"本公司"）非常重视您的隐私权。
              本隐私政策说明了我们如何收集、使用、储存和保护您的个人信息。
              使用我们的网站即表示您同意本隐私政策的条款。
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. 信息收集</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">1.1 我们收集的信息类型</h3>
            
            <div className="mb-4">
              <h4 className="text-lg font-medium text-gray-700 mb-2">个人身份信息：</h4>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>姓名、电话号码、电子邮箱地址</li>
                <li>收货地址</li>
                <li>支付信息（通过第三方支付平台处理）</li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="text-lg font-medium text-gray-700 mb-2">自动收集信息：</h4>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>IP地址、浏览器类型和版本</li>
                <li>访问时间、页面浏览记录</li>
                <li>设备信息（操作系统、屏幕分辨率等）</li>
                <li>Cookies和类似技术收集的信息</li>
              </ul>
            </div>

            <h3 className="text-xl font-medium text-gray-800 mb-3">1.2 信息收集方式</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>您主动提供的信息（注册、下单、联系我们时）</li>
              <li>自动技术收集（网站访问、Cookies等）</li>
              <li>第三方平台（支付平台、物流公司等）</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. 信息使用</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 使用目的</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li><strong>订单处理：</strong>处理您的购买订单，安排配送</li>
              <li><strong>身份验证：</strong></li>
              <li><strong>客户服务：</strong>回复咨询、处理投诉、提供技术支持</li>
              <li><strong>营销推广：</strong>发送产品信息、促销活动（需您同意）</li>
              <li><strong>网站优化：</strong>分析网站使用情况，改善用户体验</li>
              <li><strong>法律合规：</strong>遵守相关法律法规要求</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 法律依据</h3>
            <div className="bg-blue-50 p-4 rounded-lg">
              <ul className="list-disc list-inside space-y-1 text-blue-800">
                <li>合同履行需要</li>
                <li>法律法规要求</li>
                <li>用户明确同意</li>
                <li>合法经营利益</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. 信息共享与披露</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">3.1 我们不会出售您的个人信息</h3>
            <p className="text-gray-700 mb-4">
              我们承诺不会将您的个人信息出售、出租或以其他方式转让给第三方用于营销目的。
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">3.2 有限共享情况</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li><strong>服务提供商：</strong>物流配送、支付处理、技术支持等合作伙伴</li>
              <li><strong>法律要求：</strong>应政府部门、司法机关要求</li>
              <li><strong>业务转让：</strong>公司合并、收购等情况（会提前通知）</li>
              <li><strong>安全保护：</strong>保护我们或他人的合法权益</li>
            </ul>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-4">
              <p className="text-yellow-800">
                <strong>重要声明：</strong>在任何共享情况下，我们都会要求接收方采取适当的保护措施。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. 数据安全</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">4.1 技术保护措施</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>SSL加密传输技术</li>
              <li>防火墙和入侵检测系统</li>
              <li>数据加密存储</li>
              <li>定期安全评估和更新</li>
            </ul>


            <div className="bg-red-50 border-l-4 border-red-400 p-4 mt-4">
              <p className="text-red-800">
                <strong>安全提醒：</strong>虽然我们采取了多种安全措施，但请您也要保护好自己的账户信息，
                不要与他人分享密码，及时退出登录。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Cookies和跟踪技术</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">5.1 Cookies的使用</h3>
            <p className="text-gray-700 mb-3">
              我们使用Cookies来改善您的浏览体验：
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li><strong>必要Cookies：</strong>维持网站基本功能，无法禁用</li>
              <li><strong>功能Cookies：</strong>记住您的偏好设置</li>
              <li><strong>分析Cookies：</strong>了解网站使用情况</li>
              <li><strong>营销Cookies：</strong>提供个性化广告（需您同意）</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">5.2 管理Cookies</h3>
            <p className="text-gray-700">
              您可以通过浏览器设置管理Cookies，但禁用某些Cookies可能会影响网站功能。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. 您的权利</h2>
            
            <p className="text-gray-700 mb-4">根据相关法律法规，您享有以下权利：</p>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-800 mb-2">访问权</h4>
                <p className="text-sm text-gray-600">查看我们持有的您的个人信息</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-800 mb-2">更正权</h4>
                <p className="text-sm text-gray-600">要求更正不准确的个人信息</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-800 mb-2">删除权</h4>
                <p className="text-sm text-gray-600">在特定情况下要求删除个人信息</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-800 mb-2">撤回同意权</h4>
                <p className="text-sm text-gray-600">撤回您之前给予的同意</p>
              </div>
            </div>

            <div className="mt-4 p-4 bg-green-50 rounded-lg">
              <p className="text-green-800">
                <strong>行使权利：</strong>如需行使上述权利，请联系我们的客服团队。
                我们将在法定时间内回复您的请求。
              </p>
            </div>
          </section>


          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. 跨境数据传输</h2>
            <p className="text-gray-700">
              您的个人信息主要在中华人民共和国境内处理和存储。
              如有跨境传输需要，我们将严格遵守相关法律法规，确保数据安全。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. 政策更新</h2>
            <p className="text-gray-700 mb-4">
              我们可能会不时更新本隐私政策。重大变更时，我们会通过以下方式通知您：
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>在网站显著位置发布通知</li>
              <li>通过电子邮箱发送通知</li>
              <li>通过APP推送或短信通知</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. 联系我们</h2>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
              <p className="text-blue-800 mb-4">
                如您对本隐私政策有任何疑问、意见或投诉，请通过以下方式联系我们：
              </p>
              <div className="space-y-2 text-blue-800">
                <p><strong>公司名称：</strong>南昌市玉洒贸易有限公司</p>
                <p><strong>联系地址：</strong>江西省南昌市西湖区</p>
                <p><strong>客服电话：</strong>+86 13907917041</p>
                <p><strong>电子邮箱：</strong>info@ystrades.com</p>
              </div>
            </div>
          </section>

          <div className="text-center mt-8 pt-8 border-t border-gray-200">
            <p className="text-gray-500 mb-2">
              本隐私政策最后更新时间：{new Date().getFullYear()}年{new Date().getMonth() + 1}月{new Date().getDate()}日
            </p>
            <p className="text-gray-500">
              本政策自发布之日起生效
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;